<template>
    <div id="sidebar-container-fullscreen"
         class="sidebar-group-inside fullscreen"
         role="group"
         aria-label="First group"
         v-if="sidebarData.length > 0"
         v-bind:class="hasFrame == 'false' ? '' : 'sidebar-show'"
    >
        <div class="btn-sidebar-group"></div>
        <a id="toggleSideBarFull"
           class="btn-group-video btn-sidebar-group-toggle collapsed"
           data-bs-toggle="collapse"
           href="#btnGroupMenuLateral"
           role="button"
           aria-expanded="false"
           aria-controls="btnGroupMenuLateral"
        ></a>
        <div class="collapse" id="btnGroupMenuLateral">
            <div class="sidebar-group-arrow"></div>
            <div class="container-sidebar-group-menu">
                <div class="d-menu-lateral">
                    <div id="sidebar-container2" class="sidebar-group-inside sidebar-group"
                         v-if="sidebarData.length > 0">
                        <sidebar-element
                            v-for="element in sidebarData"
                            :key="element['id']"
                            :element="element" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { computed } from 'vue';
import { usePlayerStore } from '@/playerVue3/storage/storePlayer';
import SidebarElement from "@/playerVue3/components/sidebar/sidebar-element.vue";

// INITIALIZE STORE & COMPOSABLES
const store = usePlayerStore();

// PROPS
const props = defineProps({
    hasFrame: {
        default: false,
        required: true,
        type: String,
    },
});

// REACTIVE VARIABLES

// COMPUTED PROPERTIES
const sidebarData = computed(() => store.getSidebar);

// METHODS

// LYFECYCLE HOOKS
</script>
